import { useRef, useState } from "react";

import { splitFileName } from "@/common/helper/fileDownloadHelper";
import { KnownKey } from "@/common/types/KnownKey";

interface UseRenameInputParams {
  fileName: string;
  onRename: (newFileName: string) => void;
}

export function useRenameInput({ fileName, onRename }: UseRenameInputParams) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const { baseName: nameWithoutExtension, extension } = splitFileName(fileName);

  const startEditing = () => {
    setEditValue(nameWithoutExtension);
    setIsEditing(true);
    setTimeout(() => inputRef.current?.select(), 0);
  };

  const confirmRename = () => {
    const trimmed = editValue.trim();
    setIsEditing(false);
    if (trimmed && trimmed !== nameWithoutExtension) {
      onRename(trimmed + extension);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === KnownKey.Enter) {
      e.preventDefault();
      confirmRename();
    } else if (e.key === KnownKey.Escape) {
      setIsEditing(false);
    }
  };

  return { isEditing, editValue, setEditValue, inputRef, extension, startEditing, confirmRename, handleKeyDown };
}
